import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { de as LocaleDe } from "date-fns/locale/de";
import { format } from "date-fns/format";
import isEqual from "lodash/isEqual";
import { Runtime } from "@silvertours/front-entities";
import { Session, String } from "@silvertours/front-shared";
import { DeleteButtonContent, SearchHistoryDate, SearchHistoryHeadline, SearchHistoryListItem, SearchHistoryWrapper } from "./SearchHistory.styles";
var SEARCH_HISTORY_SESSION_STORAGE_KEY = "SearchHistoryKey8934087340";
var SEARCH_HISTORY_LIMIT = 6;
export var getSearchHistory = function() {
    var data = Session.SessionStorageManager.getData(SEARCH_HISTORY_SESSION_STORAGE_KEY);
    if (data) {
        return data;
    }
    return {
        items: []
    };
};
var ref, ref1, ref2, ref3, ref4, ref5;
export var mapFormToSearchItem = function(formBody) {
    var ref6, ref7, ref8, ref9, ref10, ref11;
    return {
        depAirportCode: (ref1 = (ref = (ref6 = formBody.depLocation) === null || ref6 === void 0 ? void 0 : ref6.iataCode) !== null && ref !== void 0 ? ref : (ref7 = formBody.depLocation) === null || ref7 === void 0 ? void 0 : ref7.cityCode) !== null && ref1 !== void 0 ? ref1 : "",
        destAirportCode: (ref3 = (ref2 = (ref8 = formBody.destLocation) === null || ref8 === void 0 ? void 0 : ref8.iataCode) !== null && ref2 !== void 0 ? ref2 : (ref9 = formBody.destLocation) === null || ref9 === void 0 ? void 0 : ref9.cityCode) !== null && ref3 !== void 0 ? ref3 : "",
        destName: (ref4 = (ref10 = formBody.destLocation) === null || ref10 === void 0 ? void 0 : ref10.name) !== null && ref4 !== void 0 ? ref4 : "",
        depName: (ref5 = (ref11 = formBody.depLocation) === null || ref11 === void 0 ? void 0 : ref11.name) !== null && ref5 !== void 0 ? ref5 : "",
        depDate: formBody.depDate.split("T")[0],
        depTime: formBody.depDate.split("T")[1],
        destDate: formBody.destDate.split("T")[0],
        destTime: formBody.destDate.split("T")[1],
        depWeekDay: "",
        destWeekDay: "",
        imageUrl: ""
    };
};
export var addItemToSearchHistory = function(item) {
    var history = getSearchHistory();
    if (!history.items.find(function(storedItem) {
        return isEqual(storedItem, item);
    })) {
        history.items.unshift(item);
        if (history.items.length > SEARCH_HISTORY_LIMIT) {
            history.items.pop();
        }
        Session.SessionStorageManager.setData(SEARCH_HISTORY_SESSION_STORAGE_KEY, history);
    }
};
export var clearSearchHistory = function() {
    Session.SessionStorageManager.removeData(SEARCH_HISTORY_SESSION_STORAGE_KEY);
};
var SearchHistory = function(_param) {
    var clearSearchHistoryCallback = _param.clearSearchHistoryCallback, deleteLabel = _param.deleteLabel, hidden = _param.hidden, onLastElementBlur = _param.onLastElementBlur, handleKeyDown = _param.handleKeyDown, handleItemClick = _param.handleItemClick, headline = _param.headline, history = _param.history, props = _object_without_properties(_param, [
        "clearSearchHistoryCallback",
        "deleteLabel",
        "hidden",
        "onLastElementBlur",
        "handleKeyDown",
        "handleItemClick",
        "headline",
        "history"
    ]);
    var ref;
    var language = Runtime.useLocale().language;
    var localDateFormats = String.dateFormats[language];
    var filteredItems = (ref = history.items) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
        return item.language === language || item.language === undefined;
    });
    return /*#__PURE__*/ _jsxs(SearchHistoryWrapper, _object_spread_props(_object_spread({}, props), {
        hidden: hidden || (filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.length) === 0,
        children: [
            /*#__PURE__*/ _jsx(SearchHistoryHeadline, {
                textColor: "grey",
                children: headline
            }),
            /*#__PURE__*/ _jsx("ul", {
                className: "mb-50 pt-20",
                children: filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.map(function(item, index) {
                    return /*#__PURE__*/ _jsx("li", {
                        className: "border-b-color8 py-30 px-50 hover:bg-color8 cursor-pointer border-b-[1px]",
                        children: /*#__PURE__*/ _jsxs("button", {
                            type: "button",
                            onClick: function() {
                                return handleItemClick(item);
                            },
                            onKeyDown: function(event) {
                                handleKeyDown(event, function() {
                                    return handleItemClick(item);
                                });
                            },
                            className: "searchHistory w-full text-left",
                            children: [
                                /*#__PURE__*/ _jsxs(SearchHistoryListItem, {
                                    inline: true,
                                    children: [
                                        item.depName,
                                        " ",
                                        item.destName ? " - ".concat(item.destName) : ""
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(SearchHistoryDate, {
                                    inline: true,
                                    textColor: "grey",
                                    children: [
                                        format(new Date(item.depDate), localDateFormats.dateLong, {
                                            locale: LocaleDe
                                        }),
                                        " ",
                                        "-",
                                        " ",
                                        format(new Date(item.destDate), localDateFormats.dateLong, {
                                            locale: LocaleDe
                                        })
                                    ]
                                })
                            ]
                        })
                    }, item.depName + index);
                })
            }),
            /*#__PURE__*/ _jsx("button", {
                type: "button",
                onMouseDown: clearSearchHistoryCallback,
                onKeyDown: function(event) {
                    return handleKeyDown(event, clearSearchHistoryCallback);
                },
                onBlur: onLastElementBlur,
                className: "text-color1 hover:text-color1-800 focus-visible:outline-color3 active:text-color1-900 rounded-sm focus-visible:outline-dashed focus-visible:outline-2 focus-visible:outline-offset-4",
                children: /*#__PURE__*/ _jsx(DeleteButtonContent, {
                    children: deleteLabel
                })
            })
        ]
    }));
};
export { SearchHistory };
